import dayjs from 'dayjs';

export const $getFormattedTimestamp = (timestamp: any) => {
  const currentTime = dayjs();
  const targetTime = dayjs(timestamp); // Use chat.updated_at as the target time

  const secondsAgo = currentTime.diff(targetTime, 'second');
  const minutesAgo = Math.floor(secondsAgo / 60);
  const hoursAgo = Math.floor(minutesAgo / 60);

  if (targetTime.isSame(currentTime, 'day')) {
    if (secondsAgo < 60) {
      return secondsAgo === 0 ? 'Just now' : `${secondsAgo} second${secondsAgo === 1 ? '' : 's'} ago`;
    } else if (minutesAgo < 60) {
      return `${minutesAgo} minute${minutesAgo === 1 ? '' : 's'} ago`;
    } else {
      return `${hoursAgo} hour${hoursAgo === 1 ? '' : 's'} ago`;
    }
  } else if (targetTime.isSame(currentTime.subtract(1, 'day'), 'day')) {
    return 'Yesterday';
  } else if (targetTime.isSame(currentTime, 'week')) {
    return targetTime.format('dddd');
  } else if (!targetTime.isSame(currentTime, 'year')) {
    return targetTime.format('DD/MM/YY');
  } else {
    return targetTime.format('MMM DD');
  }
};

export const $dateFormatter = (date: string | Date, format: string) => {
  return dayjs(date).format(format);
};
